/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Style } from 'radium';
import c from 'classnames';
import { NarrationTypeEnum } from 'appConsts';
import User from 'helper/currentUser';

import '../../../css/blocks.css';

import HtmlType from './LessonComponents/HtmlType';
import TextType from './LessonComponents/TextType';
import QuoteType from './LessonComponents/QuoteType';
import StatementType from './LessonComponents/StatementType';
import ImageType from './LessonComponents/ImageType';
import ListType from './LessonComponents/ListType';
import InteractiveType from './LessonComponents/InteractiveType';
import MultimediaType from './LessonComponents/MultimediaType';
// import FlashCardType from './LessonComponents/FlashCardType';
import SettingsMenu from './SettingsMenu';
import AddBlockMenu from './AddBlockMenu';
import {
  moveArrayElem,
  updateItemInItems,
  removeBlockItem,
  insertNewBlock,
  gettingStartedBlock,
  initOrModifyBP
} from './helper';
import WrapperComponent from './BlockWrapper';
import BlocksPerformanceHandler from './BlocksPerformanceHandler';

import '../../../../../../fonts/icomoon.css';
import '../../../../../../style/blocks/style.css';
import '../../../../../../fonts/fonts.css';
import '../../../../../../style/blocks/brand.css';

const user = new User();

export default class BlockLesson extends Component {
  static contextTypes = {
    getFeatureFlag: PropTypes.func
  };

  static childContextTypes = {
    dispatch: PropTypes.func
  };

  constructor(props) {
    super(props);

    // Afterwards no need to filter as directly lesson would be passed as prop.
    // const lessonId = props.lessonId;
    // const lesson = course.lessons.find(item => item.id === lessonId);

    const lesson = this.props.card;
    this.state = {
      lesson,
      blockInfo: this.props.editable ? lesson.content.blockInfo : lesson.blockInfo,
      openSettings: false,
      activeBlockItemSettings: null,
      openAddMenu: false,
      insertBlockIndex: null
    };
    this.editable = this.props.editable || false;
  }

  getChildContext() {
    return {
      dispatch: this.dispatch
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    try {
      this.state.lesson = nextProps.card;
      this.state.blockInfo = this.props.editable
        ? nextProps.card.content.blockInfo
        : nextProps.card.blockInfo;
    } catch (e) {
      console.log('nextProps are', nextProps);
    }
  }

  onTypeSelect = insertBlockIndex => (type, family, variant) => {
    const lesson = insertNewBlock(this.state.lesson, insertBlockIndex, type, family, variant);
    if (this.shouldEmptyNarration(lesson.content.narrationType, lesson.content.narrationUrl)) {
      lesson.content.narrationUrl = '';
    }
    this.updateCardInfo(lesson, true);
  };

  getFlagValue = () => {
    const companyId = user.companyId();
    switch (companyId) {
      case '56bfef41a17441a959d9c8d5': {
        return 'open-sans';
      }
      case '5a60b301583d780015188545':
      case '5b162996f7f5ad0018852021':
      case '5977532c1792d0001a20efa3':
      case '5ad8cde5c31a1d00160d3b69':
      case '5ac1f5ff68cd5700208ff99e': {
        return 'proxima-nova';
      }
      default: {
        return 'default';
      }
    }
  };

  getModeClass = () => {
    const flagValue = this.getFlagValue();
    const applyFontFix = flagValue !== 'default';
    return c(
      'BlocksContainer',
      { 'blocks-authoring': this.editable },
      { 'blocks-lesson': !this.editable },
      { fontFix: applyFontFix },
      { [flagValue]: applyFontFix }
    );
  };

  shouldEmptyNarration = (narrationType, narrationUrl) => {
    if (
      narrationUrl === null ||
      !narrationType ||
      narrationType === NarrationTypeEnum.noAudio ||
      narrationType === NarrationTypeEnum.custom
    ) {
      return false;
    }
    return true;
  };

  openAddMenu = insertBlockIndex => () => {
    this.setState({
      openAddMenu: true,
      insertBlockIndex
    });
  };

  openSettings = ({ openSettings, blockItem }) => {
    this.setState({
      openSettings,
      activeBlockItemSettings: blockItem
    });
  };

  updateCardInfo = (lesson, immediate) => {
    !immediate && this.props.onSubmit(lesson);
    immediate && this.props.onSubmit.callFuncNow(lesson);
  };

  closeAddMenu = () => {
    this.setState(
      {
        openAddMenu: false
      },
      () => {
        this.state.insertBlockIndex = null;
      }
    );
  };

  closeSideMenu = () => {
    this.setState(
      {
        openSettings: false
      },
      () => {
        this.state.activeBlockItemSettings = null;
      }
    );
  };

  dispatch = (eventType, payload, moveBlock, immediateSubmit) => {
    const lesson = this.state.lesson;
    switch (eventType) {
      case 'UPDATE_ITEM_DATA': {
        const itemId = payload._id;
        // console.log(lesson.content.blockInfo);
        const isUpdated = updateItemInItems(lesson.content.blockInfo, itemId, payload);
        if (isUpdated) {
          if (
            this.shouldEmptyNarration(lesson.content.narrationType, lesson.content.narrationUrl)
          ) {
            lesson.content.narrationUrl = '';
          }
          this.updateCardInfo(lesson, immediateSubmit);
        }
        break;
      }
      case 'UPDATE_ITEM_MEDIA': {
        const itemId = payload._id;
        const isUpdated = updateItemInItems(lesson.content.blockInfo, itemId, payload);
        if (isUpdated) {
          this.updateCardInfo(lesson, immediateSubmit);
        }
        break;
      }
      case 'REMOVE_BLOCK_ITEM': {
        const itemId = payload._id;
        const { variant } = payload;
        const isVideoOrAudioCard = variant === 'video' || variant === 'audio';
        const status = window.blockUpload[itemId] && window.blockUpload[itemId].status;
        if (isVideoOrAudioCard && (status === 'uploading' || status === 'transcoding')) {
          const request = window.blockUpload[itemId].request;
          const card = { id: itemId, blockId: itemId, level: 'block', request };
          window.eventEmitter.emitEvent('removeElementFromList', [card]);
        }
        const isUpdated = removeBlockItem(lesson.content.blockInfo, itemId, payload._id);
        if (isUpdated) {
          if (
            this.shouldEmptyNarration(lesson.content.narrationType, lesson.content.narrationUrl)
          ) {
            lesson.content.narrationUrl = '';
          }
          this.updateCardInfo(lesson, immediateSubmit);
        }
        break;
      }
      case 'MOVE_BLOCK': {
        lesson.content.blockInfo = moveArrayElem(
          lesson.content.blockInfo,
          moveBlock.oldIndex,
          moveBlock.newIndex
        );
        if (this.shouldEmptyNarration(lesson.content.narrationType, lesson.content.narrationUrl)) {
          lesson.content.narrationUrl = '';
        }
        this.updateCardInfo(lesson, immediateSubmit);
        break;
      }
      default:
        return true;
    }
  };

  updateBlocksData = (...args) => {
    this.blockPerfHandler && this.blockPerfHandler.updateBlocksData(...args);
  };

  renderSettingsMenu = () => (
    <SettingsMenu
      closeSideMenu={this.closeSideMenu}
      openMenu={this.state.openSettings}
      blockItem={this.state.activeBlockItemSettings}
      courseId={this.props.rootOfferId}
      cardId={this.props.card._id}
    />
  );

  renderAddBlockMenu = () => (
    <AddBlockMenu
      closeSideMenu={this.closeAddMenu}
      openMenu={this.state.openAddMenu}
      blockItem={this.state.activeBlockItemSettings}
      onTypeSelect={this.onTypeSelect(this.state.insertBlockIndex)}
    />
  );

  renderBlockItem = (cardId, completionType, blocksLength, blockPerformance, completionStatus) => (
    blockItem,
    i
  ) => {
    const blockItemType = blockItem.type;
    const editable = this.editable;
    const wrapperProps = {
      cardId,
      editable,
      blockItem,
      blockItemType,
      openSettings: this.openSettings,
      openAddMenu: this.openAddMenu(i + 1),
      key: i,
      dispatch: this.dispatch,
      index: i,
      blocksLength,
      completionType,
      updateBlockDataForPerformance: this.updateBlocksData
    };

    const blockItemProps = {
      lesson: blockItem,
      blockPerformance: blockPerformance[blockItem.pid],
      completionType,
      editable,
      dispatch: this.dispatch,
      preview: this.props.preview,
      completionStatus
    };

    if (blockItem === 'blank') {
      return (
        <WrapperComponent
          key="aa"
          {...wrapperProps}
          hideControls={true}
          hideEditButton={true}
          initialBlock={true}
        >
          {blocksLength < 1 && gettingStartedBlock()}
        </WrapperComponent>
      );
    }

    switch (blockItemType) {
      case 'html':
        return (
          <WrapperComponent {...wrapperProps} hideEditButton={true}>
            <HtmlType {...blockItemProps} />
          </WrapperComponent>
        );
      case 'text':
        return (
          <WrapperComponent {...wrapperProps} hideEditButton={true}>
            <TextType {...blockItemProps} />
          </WrapperComponent>
        );
      case 'quote':
        return (
          <WrapperComponent {...wrapperProps}>
            <QuoteType {...blockItemProps} />
          </WrapperComponent>
        );
      case 'impact':
        return (
          <WrapperComponent {...wrapperProps} hideEditButton={true}>
            <StatementType {...blockItemProps} />
          </WrapperComponent>
        );
      case 'image':
        return (
          <WrapperComponent {...wrapperProps}>
            <ImageType {...blockItemProps} />
          </WrapperComponent>
        );
      case 'list':
        return (
          <WrapperComponent {...wrapperProps} hideEditButton={true}>
            <ListType {...blockItemProps} />
          </WrapperComponent>
        );
      case 'multimedia':
        return (
          <WrapperComponent {...wrapperProps}>
            <MultimediaType {...blockItemProps} />
          </WrapperComponent>
        );
      case 'interactive':
        return (
          <WrapperComponent {...wrapperProps}>
            <InteractiveType {...blockItemProps} />
          </WrapperComponent>
        );
      // case 'multimedia':
      //   return (
      //     <WrapperComponent {...wrapperProps}>
      //       <FlashCardType {...blockItemProps} />
      //     </WrapperComponent>
      //   );
      default:
        return null;
    }
  };

  render() {
    const lesson = this.state.lesson;
    if (!lesson) {
      return null;
    }

    let blockPerformance =
      (this.props.card.performance &&
        JSON.parse(this.props.card.performance.blockPerformance || '{}')) ||
      {};
    // blockPerformance = JSON.parse(blockPerformance);
    blockPerformance = initOrModifyBP(blockPerformance, this.state.blockInfo);

    return (
      <div className={this.getModeClass()}>
        <BlocksPerformanceHandler
          blocks={this.state.blockInfo}
          ref={ref => (this.blockPerfHandler = ref)}
          blockPerformance={blockPerformance}
          card={this.props.card}
          cardId={this.props.card.pid}
          completionType={this.props.card.completionType}
          previewCourse={this.props.preview}
          guestMode={this.props.guestMode}
          cardPerformance={this.props.card.performance}
          setScrollPM={this.props.setScrollPM}
          minProgressMeasure={this.props.card.minProgressMeasure}
          courseId={this.props.courseId || this.props.rootOfferId}
        />
        {this.editable && this.renderSettingsMenu()}
        {this.editable && this.renderAddBlockMenu()}
        {this.editable &&
          this.renderBlockItem(
            this.props.card.pid,
            this.props.card.completionType,
            this.state.blockInfo.length,
            blockPerformance,
            this.props.card.performance && this.props.card.performance.completionStatus
          )('blank', -1)}
        {this.state.blockInfo.map(
          this.renderBlockItem(
            this.props.card.pid,
            this.props.card.completionType,
            this.state.blockInfo.length,
            blockPerformance,
            this.props.card.performance && this.props.card.performance.completionStatus
          )
        )}
        <Style
          rules={{
            /* '.ant-layout-content': {
              padding: '0px !important',
              backgroundColor: '#FFF',
            }, */
            '.blocks-authoring': {
              borderTop: 0
            }
          }}
        />
      </div>
    );
  }
}
